<template src="@/templates/bookings/bookingConfirmed.html"></template>

<script>
import BookingConfirmedCollection from "@/collections/bookingConfirmedCollection";
import datePickerSingle from "@/components/datePicker/Single";
import BookingListItem from "@/components/bookings/BookingListItem";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "BookingConfirmed",
  props: ["booking_view"],
  components: {
    datePickerSingle,
    BookingListItem,
  },
  data() {
    return {
      bookingConfirmedCollection: new BookingConfirmedCollection(),
      bookingTitle: "",
      searchDate: {
        show: this.isSearchShow,
        startDate: "",
        endDate: "",
        searchButtonShow: false,
      },
      bookingConfirmedKey: 0,
      clockONReq: "",
      topJob: 0,
      availableError: "",
    };
  },
  computed: {
    ...mapGetters([
      "getClockOnOffMessage",
      "isSearchShow",
      "getIsInterval",
      "getSearchedDate",
    ]),
    getTitle() {
      if (this.booking_view == "confirmed") {
        return "Current Confirmed Bookings";
      } else if (this.booking_view == "confirmed_today") {
        return "Today's Confirmed Bookings";
      } else if (this.booking_view == "search_confirmed") {
        return "Search Confirmed Bookings";
      } else {
        return "Search Confirmed Bookings By Day";
      }
    },
  },
  mounted() {
    Event.$on("invokeSearchPopUp", () => {
      this.fetchData();
    });
  },
  created: function () {
    // console.log('searchDate.startDate');
    // console.log(this.searchDate.startDate);
    this.fetchData();
  },
  watch: {
    $route: "fetchData",
    getIsInterval: {
      handler: function (value) {
        if (this.getIsInterval) {
          console.log("getIsInterval");
          console.log(value);
          Event.$emit("getClockOnOffStatus");
          this.updateIsInterval(false);
        }
      },
    },
  },
  methods: {
    ...mapActions([
      "highlightJob",
      "updateJobMatchingConditions",
      "updateBookingsConfirmed",
      "updateHideAll",
      "updateIcon",
      "updateSearchStateHide",
      "updateSearchPopUpShow",
      "updateBackButton",
      "updateSearchState",
      "clearIntervalVariable",
      "updateIsInterval",
    ]),

    fetchData() {
      this.updateHideAll();
      this.updateBackButton(false);

      this.bookingConfirmedCollection = new BookingConfirmedCollection();
      this.runSearchDate();

      if (this.booking_view == "confirmed") {
        this.getBookingConfirmed();
      } else if (this.booking_view == "confirmed_today") {
        this.assignDateAsNow();
        this.getBookingConfirmed();
      } else if (this.booking_view == "search_confirmed_by_day") {
        if (this.getSearchedDate) {
          this.searchDate.startDate = this.getSearchedDate;
          this.searchDate.endDate = this.getSearchedDate;
        } else {
          this.assignDateAsNow();
        }

        this.getBookingConfirmed();
      }
    },
    assignDateAsNow() {
      let now = moment().format("YYYY-MM-DD");
      this.searchDate.startDate = now;
      this.searchDate.endDate = now;
    },
    runSearchDate() {
      if (this.booking_view == "search_confirmed") {
        this.searchDate.show = true;
        this.updateSearchStateHide(false);
        this.updateSearchState(true);
        this.updateSearchPopUpShow(true);
        this.updateIcon(["search"]);
        this.availableError = "Confirmed Bookings Not Found";
        this.searchDate.searchButtonShow = true;
      } else {
        this.searchDate.show = false;
        this.updateSearchState(false);
        this.updateSearchPopUpShow(false);
        this.searchDate.searchButtonShow = false;
      }
    },
    bookingType(booking_type) {
      let value = "";
      switch (booking_type) {
        case "Inter":
          value = "Onsite Interpreting";
          break;
        case "Ph Int":
          value = "Phone Interpreting";
          break;
        case "Video":
          value = "Video";
          break;
        case "Trans":
          value = "Translation";
          break;
        default:
          break;
      }
      return value;
    },
    getBookingConfirmed() {
      this.$vs.loading();
      let url = "";
      if (
        this.booking_view == "search_confirmed" ||
        this.booking_view == "search_confirmed_by_day" ||
        this.booking_view == "confirmed_today"
      ) {
        url =
          this.$interpretersApiUrl +
          this.bookingConfirmedCollection.getRoute("fetch") +
          "?startDate=" +
          this.searchDate.startDate +
          "&endDate=" +
          this.searchDate.endDate;
      } else {
        url =
          this.$interpretersApiUrl +
          this.bookingConfirmedCollection.getRoute("fetch");
      }

      this.bookingConfirmedCollection
        .fetch({
          url: url,
          headers: { Bearer: localStorage.getItem("jwt") },
        })
        .then(() => {
          if (this.bookingConfirmedCollection.models.length > 0) {
            this.availableError = "";
            this.updateBookingsConfirmed(true);
            this.clearIntervalVariable();

            let thisComp = this;
            const checkClockStates = async () => {
              const models = Object.entries(
                this.bookingConfirmedCollection.models
              );
              for (const [key, model] of models) {
                await thisComp.updateJobMatchingConditions([key, model]);
              }
            };

            checkClockStates().then(() => {
              /** Only triggers after the checkClockStates function's execution finalised **/
              Event.$emit("getClockOnOffStatus");
              this.$vs.loading.close();
            });
          } else {
            this.availableError = "No Confirmed Bookings Found!";
            this.$vs.loading.close();
          }

          if (this.booking_view == "search_confirmed") {
            this.searchDate.show = false;
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.error("error status code");
          console.log(error.response.response.status);
          if (error.response) {
            if (error.response.response.status == "401") {
              Event.$emit("tokenExpiredLogout");
            }
          }
          debugger;
        });
    },
    closeSearchDate() {
      this.searchDate.show = false;
      //Testing for the Git Hook Only//
    },
    searchConfirmed() {
      if (
        this.searchDate.startDate == "" ||
        this.searchDate.startDate == null ||
        this.searchDate.endDate == "" ||
        this.searchDate.endDate == null
      ) {
        this.$vs.notify({
          title: "Invalid Date",
          text: "Both Start and End date must be supplied!",
          color: "warning",
          icon: "error",
          position: "top-right",
        });
        return;
      }

      this.getBookingConfirmed();
    },
    changeDate(action) {
      if (action == "back") {
        this.searchDate.startDate = moment(this.searchDate.startDate)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      }
      if (action == "forward") {
        this.searchDate.startDate = moment(this.searchDate.startDate)
          .add(1, "days")
          .format("YYYY-MM-DD");
      }
      this.searchDate.endDate = this.searchDate.startDate;
      this.getBookingConfirmed();
    },
    checkHighlightJob(ref_num, returnedState) {
      if (this.bookingConfirmedCollection.models[0].ref_num === ref_num) {
        this.topJob = ref_num;
        return returnedState;
      }
    },
  },
};
</script>

<style scoped>
#availableHeader {
  text-align: left;
  list-style: none;
}

#availableHeader li {
  margin-bottom: 8px;
}

#ulBookingAvailable {
  list-style: none;
}

#ulBookingAvailable > li {
  padding: 10px;
}

#ulBookingAvailable > li:nth-child(odd) {
  background: #ffffff;
}

#ulBookingAvailable > li:nth-child(even) {
  background: #eeeeee;
}

#ulBookingAvailableItem {
  list-style: none;
}

#ulBookingAvailableItem > li {
  text-align: left;
}

.ftrBtn {
  float: right;
  margin-left: 10px;
}

.inputSearchDate {
  width: 100%;
}
</style>
